import React from 'react';
import '../styles/Custom.css';
import Typography from './Typography';

const CustomButton = ({
    text,
    type = 'button',
    onClick,
    disabled = false,
    variant = 'primary',
    icon,
    className = '',
    background,
    bgColor = '#DF0F11',
    textColor = '#FFFFFF',
    fontSize = '16px',
    strock,
}) => {
    return (
        <button
            type={type}
            onClick={onClick}
            disabled={disabled}
            className={`custom-button ${variant} ${className} ${disabled ? 'disabled' : ''}`}
        >
            {background ? background : <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 464 48"
                fill="none"
                preserveAspectRatio="none"
                className={`button-svg`}
            >
                <path
                    d="M0 6C0 2.68629 2.68629 0 6 0H447.78C449.213 0 450.598 0.512353 451.685 1.44446L461.905 10.2041C463.235 11.344 464 13.0081 464 14.7596V42C464 45.3137 461.314 48 458 48H16.2196C14.7873 48 13.4023 47.4876 12.3148 46.5555L2.09525 37.7959C0.765376 36.656 0 34.9919 0 33.2404V6Z"
                    fill={bgColor}
                    stroke={strock}
                    strockwidth="2px"
                />
            </svg>}
            <div className="button-content">
                {icon && <span className="button-icon">{icon}</span>}
                <Typography text={text} size={fontSize} transform={'uppercase'} color={textColor} family={'Supply'} />
            </div>
        </button>
    );
};

export default CustomButton;